import { render } from "./PaymentMethod.vue?vue&type=template&id=e309841a"
import script from "./PaymentMethod.js?vue&type=script&lang=js"
export * from "./PaymentMethod.js?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__